module.exports = __webpack_public_path__ + "img/title_uk.a630acbe.svg";